<template>
  <div class="badges">
    <h2 class="badges__title">Bekroningen</h2>
    <p class="tag badges__explanation"><em>Deel een bekroning uit als de leerling boven zichzelf uitstijgt (op zijn niveau) in een vaardigheid.</em></p>
    <div class="badges__list">
      <div
        v-for="badge in badges"
        :key="badge.type"
        :class="[ `badge--${badge.type}`, { 'badge--active': badge.type === selectedBadge && !isLoading, 'badge--disabled': disabled } ]"
        class="badges__item badge"
        @click.prevent="selectBadge(badge)">
        <div class="badge__icon"></div>
        <p class="badge__type tag">{{ badge.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import api from 'js/api/resources'
import { transform } from 'js/vuex/helpers'
import track from 'js/helpers/analytics'

export default {
    components: {},

    props: {
        progress: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data: function () {
        return {
            isLoading: false
        }
    },

    vuex: {
        actions: {
            patchBadge: ({ dispatch }, progress, badge) => {

                return api.patchBadge(progress.id, badge)
                    .then( response => transform(response.body) )
                    .then( result => {
                        const badge = (result.badges || [])[0]
                        dispatch('ADD_BADGES', result.badges || [])
                        dispatch('ADD_PROGRESS', result.progress || [])
                        return badge
                    })
            },
            fakeBadge: ({ dispatch }, progress, badge) => {

                const fake = {
                    id: 'fake-' + progress.id,
                    tag: badge,
                }

                dispatch('ADD_BADGES', [fake])
                dispatch('ADD_BADGE_TO_PROGRESS', progress.id, fake.id)
            }
        }
    },

    computed: {
        badges () {
            return [{
                type: 'idea',
                name: 'Ideevorming',
                color: 'blue',
            }, {
                type: 'design',
                name: 'Vormgeving',
                color: 'red',
            }, {
                type: 'technique',
                name: 'Materiaal & techniek',
                color: 'yellow',
            }, {
                type: 'artappreciation',
                name: 'Kunstbeschouwing',
                color: 'green',
            }, {
                type: 'reflection',
                name: 'Reflectie',
                color: 'purple',
            }]
        },
        selectedBadge () {
            if (this.disabled || this.progress.badge == null) {
                return null
            }
            return this.$store.state.badges.storage[ this.progress.badge[0] ].type
        }
    },

    methods: {
        selectBadge (badge) {
            if (this.disabled) {
                return
            }

            const newVal = badge.type === this.selectedBadge ? null : badge.type

            if ( this.isDemo ) {
                return this.fakeBadge(this.progress, newVal)
            }

            this.isLoading = true
            this.patchBadge(this.progress, newVal)
                .catch( err => {
                    track.exception('Could not store badge', err)
                })
                .then(() => {
                    this.isLoading = false
                })
        }
    }
}
</script>

<style lang="scss">
    @import 'global';

$badge-types: (
    design: 'design',
    reflection: 'reflection',
    technique: 'technique',
    idea: 'idea',
    artappreciation: 'artappreciation',
);

.badges {

  &__list {
    display: flex;
  }

  &__item {
    flex: 1 1 0;
    min-width: 0;
  }
}

.badge {
  text-align: center;
  &__type {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__icon {
    width: 100%;
    max-width: 128px;
    margin: 0 auto;

    background-image: make-img-url('badges/badge-artappreciation-256x.png');
    background-size: contain;
    background-repeat: no-repeat;
    /* height ratio of 1:1*/
    &:before{
      content: "";
      display: block;
      padding-top: 100%;
    }
  }

  @each $type, $value in $badge-types {
    &--#{$type} {
      .badge__icon {
        background-image: make-img-url('badges/badge-#{$value}-256x.png');
      }
    }
  }

  &:hover {
    cursor: pointer;
  }

  @each $type, $value in $badge-types {
    &--#{$type} {
      &.badge--active .badge__icon, &:not(.badge--disabled):hover .badge__icon {
        background-image: make-img-url('badges/badge-#{$value}-color-256x.png');
      }
    }
  }

  &--disabled {
    opacity: 0.5;
    &:hover {
      cursor: not-allowed;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Badges.vue?4d9d2e9c